import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from "react";

const field = "block w-full rounded-md border border-gray-300 bg-white text-sm text-gray-900 placeholder-gray-400 shadow-sm focus:border-accent-500 focus:ring-1 focus:ring-accent-500/40 focus:outline-none";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className = "", ...rest }, ref) => (
    <input ref={ref} className={`${field} px-3 py-2 ${className}`} {...rest} />
  )
);
Input.displayName = "Input";

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className = "", rows = 3, ...rest }, ref) => (
    <textarea ref={ref} rows={rows} className={`${field} px-3 py-2 ${className}`} {...rest} />
  )
);
Textarea.displayName = "Textarea";

export function Label({ children, htmlFor, hint }: { children: React.ReactNode; htmlFor?: string; hint?: string }) {
  return (
    <label htmlFor={htmlFor} className="block text-xs font-medium text-gray-700 mb-1">
      {children}
      {hint && <span className="ml-1 text-gray-400 font-normal">{hint}</span>}
    </label>
  );
}
